// src/components/ia-paca/IaPacaCTA.tsx
//
// CTA récurrent en bas des pages /ia-paca/ — convertit le visiteur
// qui a scrollé jusqu'au bout. Gradient brand + microcopy concret.

import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';

interface IaPacaCTAProps {
  title?: string;
  subtitle?: string;
  primaryLabel?: string;
  secondaryLabel?: string;
}

export default function IaPacaCTA({
  title = 'Vous avez un poste IA à pourvoir en PACA ?',
  subtitle = "Un de nos profils techniques vous rappelle sous 24h pour un brief de 30 min. On définit ensemble le poste, les critères réels, et on lance le sourcing si on est aligné. Aucune obligation.",
  primaryLabel = 'Réserver 30 min',
  secondaryLabel = 'Recevoir le baromètre salaires',
}: IaPacaCTAProps) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-violet-950 to-pink-950 py-16 lg:py-20">
      <div
        aria-hidden
        className="pointer-events-none absolute -top-20 -right-20 h-72 w-72 rounded-full bg-pink-500/30 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-20 -left-20 h-72 w-72 rounded-full bg-violet-500/30 blur-3xl"
      />
      <div className="relative mx-auto max-w-4xl px-6 text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          {title}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
          {subtitle}
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/reservation"
            className="group inline-flex items-center gap-2 rounded-xl bg-white px-6 py-3.5 text-sm font-semibold text-slate-900 shadow-lg transition hover:shadow-xl"
          >
            <Calendar className="h-4 w-4" />
            {primaryLabel}
            <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" />
          </Link>
          <Link
            to="/ia-paca/barometre-salaires-ia-paca-2026"
            className="inline-flex items-center gap-2 rounded-xl border border-white/30 bg-white/5 px-6 py-3.5 text-sm font-semibold text-white backdrop-blur transition hover:bg-white/10"
          >
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
